// theme constant
export const gridSpacing = 3;
/** Sidebar / nav drawer width. */
export const drawerWidth = 240;
export const appDrawerWidth = 320;
